module.exports = __webpack_public_path__ + "img/UTGUNL-7.d75f51f0.jpg";